module.exports = __webpack_public_path__ + "static/media/sofia.ebfd90e7.jpg";